<label *ngFor="let option of internalOptions">
  <input type="checkbox" [value]="option.value" [checked]="option.checked" (change)="toggleOption(option, $event)" />
  {{ option.label }}
</label>
